import Container from '../../components/menu/Container';
import { useTranslation } from "react-i18next";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useEffect, useState } from 'react';
import findFatura from '../../service/findFatura';
import { SortOrder } from 'primereact/api';
import { useGlobalState } from '../../components/globalState/GlobalStateProvider';
import { Dropdown } from 'primereact/dropdown';
import findClient from '../../service/findClient';
import { Toolbar } from 'primereact/toolbar';
import findFaturamento from '../../service/findFaturamento';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import getFaturaDownload from '../../service/getFaturaDownload';
import getFaturaDownloadRegistro from '../../service/getFaturaDownloadRegistro';
import getFaturaDownloadConsulta from '../../service/getFaturaDownloadConsulta';


export default function FaturaPage() {
  const { t } = useTranslation();
  const [faturas, setFaturas] = useState(undefined);
  const [totalRecords, setTotalRecords] = useState(0);
  const [expandedRows, setExpandedRows] = useState(undefined);
  const {state} = useGlobalState();
  const [selectedClient, setSelectedClient] = useState<any>(null);
  const [clients, setClients] = useState<any>([]);
  const [selectedFaturamento, setSelectedFaturamento] = useState<any>(null);
  const [faturamentos, setFaturamentos] = useState<any>([]);
  const [counts, setCounts] = useState([]);
  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 1,
    faturamento: selectedFaturamento ? selectedFaturamento.code : null,
    cliente: selectedClient ? selectedClient.code : null,
    idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
    sortField: 'cliente.nome',
    sortOrder: SortOrder.ASC
  });

  const onPage = (event: any) => {
    setlazyState({
      first: event.first,
      rows: event.rows,
      page: (event.first / event.rows) + 1,
      faturamento: selectedFaturamento ? selectedFaturamento.code : null,
      cliente: selectedClient ? selectedClient.code : null,
      idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };

  const onSort = (event:any) => {
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      faturamento: selectedFaturamento ? selectedFaturamento.code : null,
      cliente: selectedClient ? selectedClient.code : null,
      idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };

  const rowExpansionTemplate = (data:any) => {
    
    return (
        <div>
            <h5>Itens Fatura</h5>
            <DataTable value={data.itens}>
                <Column field="servico" header={t('servico')} sortable></Column>
                <Column field="quantidade" header={t('quantidade')} sortable></Column>
                <Column field="valor" header={t('valor')} sortable></Column>
                <Column field="total" header={t('total')} sortable></Column>
            </DataTable>
        </div>
    );
  };

  const loadLazyData = () => {
    findFatura(lazyState).then(data => {setTotalRecords(data.total);setCounts(data.resumos);setFaturas(data.faturas)}).catch(() => {setTotalRecords(0);setCounts([]);setFaturas(undefined)});
  }

  const changeCliente = (value:any) => {
    setSelectedClient(value);
    setlazyState({
      first: 0,
    rows: 10,
    page: 1,
    faturamento: selectedFaturamento ? selectedFaturamento.code : null,
    cliente: value ? value.code : null,
    idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
    sortField: 'cliente.nome',
    sortOrder: SortOrder.ASC
    });
  };

  const changeFaturamento = (value:any) => {
    setSelectedFaturamento(value);
    setlazyState({
      first: 0,
    rows: 10,
    page: 1,
    faturamento: value ? value.code : null,
    cliente: selectedClient ? selectedClient.code : null,
    idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
    sortField: 'cliente.nome',
    sortOrder: SortOrder.ASC
    });
  };

  const startContent = (
    <div className="filtros">
      <div className="filtros-grid">
        <div className="filtros-item">
          <label htmlFor="faturamento" className="font-bold">{t("faturamento")}</label>
          <Dropdown inputId="faturamento" value={selectedFaturamento} onChange={(e) => {changeFaturamento(e.value)}} options={faturamentos} optionLabel="name" placeholder="Selecione Faturamento"
            showClear filter />
        </div>
        {!state.user.cliente && (
          <div className="filtros-item">
            <label htmlFor="cliente" className="font-bold">{t("cliente")}</label>
            <Dropdown inputId="cliente" value={selectedClient} onChange={(e) => {changeCliente(e.value)}} options={clients} optionLabel="name" placeholder="Selecione Cliente"
              showClear filter />
          </div>
        )}
      </div>
    </div>
  );

  const formatDate = (value: { toLocaleDateString: (arg0: string, arg1: { day: string; month: string; year: string; }) => any; }) => {
    return value.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
  };

  useEffect(() => {
    if(!state.user.cliente){
      const lazyClient = {
        first: 0,
        rows: 99999999,
        page: 1,
        cliente: 'null',
        documento: 'null',
        codigoClienteErp: null,
        inativo: null,
        idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
        sortField: 'nome',
        sortOrder: SortOrder.DESC
      }
      const clientes : any[] = [];
      
      findClient(lazyClient).then(data => {
        data.clientes.forEach( (c: { nome: string; id: string; }) => {
          clientes.push({name: c.nome, code:c.id})
        })
      })
      setClients(clientes);
    }

    const lazyFaturamento = {
      first: 0,
      rows: 20,
      page: 1,
      data: null,
      status: null,
      idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      sortField: 'dataReferencia',
      sortOrder: SortOrder.DESC
    }
    const faturamentos : any[] = [];
    
    findFaturamento(lazyFaturamento).then(data => {
      data.faturamentos.forEach( (c: { dataReferencia: Date; id: string; }) => {
        faturamentos.push({name: formatDate(c.dataReferencia), code:c.id})
      })
      setSelectedFaturamento(faturamentos[0])
      changeFaturamento(faturamentos[0])
    })
    setFaturamentos(faturamentos);

  },[])

  const downloadFatura = (fatura: any) => {
    getFaturaDownload(fatura.id).then((blobFile: Blob) => {
      const url = window.URL.createObjectURL(
        new Blob([blobFile], { type: "octet/stream" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `fatura.pdf`);

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      document.body.removeChild(link);
    });
  };
  
  const downloadFaturaRegistro = (fatura: any) => {
    getFaturaDownloadRegistro(fatura.id).then((blobFile: Blob) => {
      const url = window.URL.createObjectURL(
        new Blob([blobFile], { type: "octet/stream" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `fatura_registro.pdf`);

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      document.body.removeChild(link);
    });
  };

  const downloadFaturaConsulta= (fatura: any) => {
    getFaturaDownloadConsulta(fatura.id).then((blobFile: Blob) => {
      const url = window.URL.createObjectURL(
        new Blob([blobFile], { type: "octet/stream" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `fatura_consulta.pdf`);

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      document.body.removeChild(link);
    });
  };

  const downloadTemplate = (fatura: any) => {
    return (
      <>
        {state.user.funcoes.includes("FATURA_IMPRIMIR") && (
            <>
              <Button
                icon="pi pi-file-pdf"
                onClick={() => {
                  downloadFatura(fatura);
                }}
                style={{
                  background: "transparent",
                  color: "gray",
                  border: "none",
                }}
              />
              {fatura.possuiRegistro &&  (
                <Button
                  icon="pi pi-id-card"
                  onClick={() => {
                    downloadFaturaRegistro(fatura);
                  }}
                  style={{
                    background: "transparent",
                    color: "gray",
                    border: "none",
                  }}
                />
              )}
              {fatura.possuiConsulta &&  (
                <Button
                  icon="pi pi-search"
                  onClick={() => {
                    downloadFaturaConsulta(fatura);
                  }}
                  style={{
                    background: "transparent",
                    color: "gray",
                    border: "none",
                  }}
                />
              )}
            </>
          )}
      </>
    );
  };

  useEffect(() => {
    if(lazyState.faturamento){
      loadLazyData();
    }
  },[lazyState])

  return (
    <Container>
      <div className="row">
          <div className="col-lg-12 mb-3">
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
              <h1 className="h3 mb-0 text-gray"><i className="pi pi-dollar" style={{ fontSize: '2.0rem' }}></i> {t('faturas')}</h1>
            </div>     
          </div>
      </div>
      <div className="card">
       <Toolbar start={startContent} />
        <br></br>
        <div className="flex-consulta  flex-wrap gap-3">
            {counts.map((item:any, index:number) => (
                
                <Card className='flex-1' style={{backgroundColor: '#e6ffe6'}} key={index}>
                    <div className="flex-consulta  justify-content-between gap-5">
                        <div className="flex-consulta  flex-column gap-1">
                            <span style={{color: '#008000'}} className=" text-sm">{item.label}</span>
                            <span style={{color: '#008000'}} className="font-bold text-lg">{item.value}</span>
                        </div>
                        <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor:'#008000' , color: 'white' }}>
                            <i className={'pi ' + item.icon} />
                        </span>
                    </div>
                </Card>
                
            ))}
        </div>
        <br></br>
        <DataTable value={faturas} first={lazyState.first} dataKey="id" paginator={true}  lazy={true}
                        emptyMessage="Sem registros" expandedRows={expandedRows} onRowToggle={(e:any) => setExpandedRows(e.data)}
                        rowExpansionTemplate={rowExpansionTemplate}
                        onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
                        rows={lazyState.rows} totalRecords={totalRecords} onPage={onPage}
                        tableStyle={{ minWidth: '75rem' }}>
           <Column expander={true} style={{ width: '1.5rem' }} />              
           <Column field="cliente" sortable sortField='cliente.nome' header={t('cliente')}  />
           <Column field="dataReferencia" sortable header={t('dataReferencia')}  />
           <Column field="dataVencimento" sortable header={t('dataVencimento')}  />
           <Column field="valorMinimo" sortable header={t('vcm')}  /> 
           <Column field="valorConsumo" sortable header={t('valorConsumo')}  /> 
           <Column field="valorComplementar" sortable header={t('valorComplementar')}  /> 
           <Column field="valor" sortable header={t('valor')}  /> 
           <Column style={{width: '11%'}} body={downloadTemplate} />
        </DataTable> 
      </div>
                
    </Container>
  )
}
